export const childsPlataformas = [
  {
    path: "zoho-crm",
    name: "admin-plataformas-zoho-crm",
    component: () =>
      import(
        /* webpackChunkName: "plataformas-zoho-crm" */ "@/modules/admin/pages/plataformas/ZohoCrm.vue"
      ),
  },
  {
    path: "zoho-desk",
    name: "admin-plataformas-zoho-desk",
    component: () =>
      import(
        /* webpackChunkName: "plataformas-zoho-desk" */ "@/modules/admin/pages/plataformas/ZohoDesk.vue"
      ),
  },
  {
    path: "bitrix24",
    name: "admin-plataformas-bitrix24",
    component: () =>
      import(
        /* webpackChunkName: "plataformas-bitrix24" */ "@/modules/admin/pages/plataformas/Bitrix24.vue"
      ),
  },
  {
    path: "manualBitrix",
    name: "admin-plataformas-manualBitrix",
    component: () =>
      import(
        /* webpackChunkName: "plataformas-manualBitrix" */ "@/modules/admin/pages/plataformas/ManualBitrix24.vue"
      ),
  },
  {
    path: "facebook",
    name: "admin-plataformas-facebook",
    component: () =>
      import(
        /* webpackChunkName: "plataformas-facebook" */ "@/modules/admin/pages/plataformas/Facebook.vue"
      ),
  }
];
